<script setup lang="ts">
const { isImpersonating, session } = useAuth()
</script>
<template>
  <div class="min-h-svh w-full bg-zinc-100">
    <svg
      class="stroke-dasharray-[none] stroke-dashoffset-[0] pointer-events-none absolute inset-0 z-0 h-full w-full"
      style="
        -webkit-mask-image: radial-gradient(
          ellipse at 60% 45%,
          #000 30%,
          transparent 100%
        );
        mask-image: radial-gradient(
          ellipse at 60% 45%,
          #000 30%,
          transparent 100%
        );
      "
      aria-hidden="true"
    >
      <pattern
        id="p-onboarding-dots"
        x="0"
        y="0"
        width="12"
        height="12"
        patternUnits="userSpaceOnUse"
      >
        <circle
          cx="6"
          cy="6"
          r="0.75"
          fill="#D9DDE3"
          class="stroke-dasharray-[none] stroke-dashoffset-[0]"
        />
      </pattern>
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        fill="url(#p-onboarding-dots)"
        class="stroke-dasharray-[none] stroke-dashoffset-[0]"
      />
    </svg>

    <div class="flex flex-col items-center justify-center gap-4">
      <slot />
    </div>
    <NotificationToast />
    <ImpersonatingBadge
      v-if="session && isImpersonating"
      :email="session.user.email"
    />
    <DeveloperToolbox />
  </div>
</template>
<style>
@reference "tailwindcss";
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from {
  opacity: 0;
  @apply translate-x-10;
}
.page-leave-to {
  opacity: 0;
  @apply -translate-x-10;
}
</style>
